<template>
    <div class="confirmation">
        <div class="confirmation__checkboxes">
            <input-checkbox v-for="(item, index) in checkboxes"
                :key="index"
                :index="index"
                :text="item.text"
                :maxWidth="false"
                isRound
                isWholeAreaClickable
                @toggleCheckBox="toggleCheckBox"
            />
        </div>

        <div :class="['confirmation__button', {'confirmation__button--disabled': !sendEnabled || isFormProcessing}]"
            @click="submit"
        >
            {{ $t('global.button.submit') }}
        </div>
    </div>
</template>

<script>
// Components
import inputCheckbox from '@webapp/components/inputs/input-checkbox.vue';

export default {
    name: 'kyc-confirmation',
    components: {
        inputCheckbox,
    },
    props: {
        checkboxes: {
            type: Array,
            default: () => ([]),
        },
        isFormProcessing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        sendEnabled() {
            return this.checkboxes.every((item) => item.value);
        },
    },
    methods: {
        toggleCheckBox({
            index,
            value,
        }) {
            this.checkboxes[index].value = value;
        },
        submit() {
            this.$emit('submit');
        },
    },
};
</script>

<style lang="scss" scoped>
.confirmation {
    padding-top: 2.5rem;
    display: flex;
    width: 100%;
    flex-wrap: wrap;

    &__checkboxes {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-wrap: wrap;

        &--disabled {
            pointer-events: none;
            justify-content: space-around;
        }

        @include min-width(lg) {
            flex-wrap: nowrap;
        }
    }

    &__button {
        margin-top: 1.4rem;
        margin-left: auto;
        margin-right: auto;
        height: 4rem;
        width: 16rem;
        border-radius: 0.5rem;
        background: $lima-color;
        text-align: center;
        line-height: 4rem;
        color: $daintree-color;
        font-size: 1.8rem;

        &:hover {
            cursor: pointer;
            opacity: 0.8;
        }

        &--disabled {
            background: $lima-color-opaque;
            cursor: default;
        }

        @include min-width(lg) {
            width: 22rem;
        }

        @include min-width(xl) {
            margin-right: 0;
        }
    }
}
</style>